/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{C33CFFA2-0DDC-4E83-BA2B-81FED5B4C3E5}",
  "sitecoreApiHost": "https://www.crackerbarrel.com",
  "jssAppName": "cb-brandsite",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/cb-brandsite",
  "graphQLEndpoint": "https://www.crackerbarrel.com/api/cb-brandsite?sc_apikey={C33CFFA2-0DDC-4E83-BA2B-81FED5B4C3E5}"
};